import {
	IContactUsRequestData,
	ICreateDeviceRequestData,
	ICreateInterceptorRequestData,
	IDeviceConfigurationDetails,
	IEditInterceptorRequestData,
	IGetDeviceCamerasListRequestData,
	IGetDeviceCamerasListResponseData,
	IGetDevicesConfigurationsRequestData,
	IGetDevicesConfigurationsResponseData,
	IGetInterceptorsListRequestData,
	IGetInterceptorsListResponseData,
	IInterceptorDetails
} from "../../types";
import { getAPIHeaderOptions, transformErrorResponse } from "../../utils/apiUtils";
import { queries } from "./queries.reducer";

const configuration = queries.injectEndpoints({
	endpoints: (builder) => ({
		// GET DEVICES CONFIGURATIONS
		getDevicesConfigurations: builder.query<
			IGetDevicesConfigurationsResponseData,
			IGetDevicesConfigurationsRequestData
		>({
			query: (requestData) => ({
				url: "/devices/device",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET DEVICE CAMERAS LIST
		getDeviceCamerasList: builder.query<IGetDeviceCamerasListResponseData, IGetDeviceCamerasListRequestData>({
			query: (requestData) => ({
				url: "/devices/camera",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET INTERCEPTORS LIST
		getInterceptorsList: builder.query<IGetInterceptorsListResponseData, IGetInterceptorsListRequestData>({
			query: (requestData) => ({
				url: "/analytics/interceptor",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			}),
			transformResponse: (baseQueryReturnValue: IGetInterceptorsListResponseData | IInterceptorDetails[]) => {
				if (Array.isArray(baseQueryReturnValue)) {
					return {
						count: baseQueryReturnValue.length,
						next: null,
						previous: null,
						results: baseQueryReturnValue
					};
				}
				return baseQueryReturnValue;
			}
		}),

		// CREATE INTERCEPTOR
		createInterceptor: builder.mutation<IInterceptorDetails, ICreateInterceptorRequestData>({
			query: (requestData) => ({
				url: "/analytics/interceptor",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse
		}),

		// EDIT INTERCEPTOR
		editInterceptor: builder.mutation<IInterceptorDetails, IEditInterceptorRequestData>({
			query: (requestData) => ({
				url: `/analytics/interceptor/${requestData.id}`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData.data
			}),
			transformErrorResponse
		}),

		// DELETE INTERCEPTOR
		deleteInterceptor: builder.mutation<IInterceptorDetails, number>({
			query: (id) => ({
				url: `/analytics/interceptor/${id}`,
				headers: getAPIHeaderOptions(true),
				method: "DELETE"
			}),
			transformErrorResponse
		}),

		// CREATE DEVICE
		createDevice: builder.mutation<IDeviceConfigurationDetails, ICreateDeviceRequestData>({
			query: (requestData) => ({
				url: "/devices/device",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse
		}),

		// CONTACT US
		contactUs: builder.mutation<unknown, IContactUsRequestData>({
			query: (requestData) => ({
				url: "/analytics/contactus",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse
		})
	})
});

export const {
	// GET DEVICES CONFIGURATIONS
	useGetDevicesConfigurationsQuery,
	// GET DEVICE CAMERAS LIST
	useGetDeviceCamerasListQuery,
	// GET INTERCEPTORS LIST
	useGetInterceptorsListQuery,
	// CREATE INTERCEPTOR
	useCreateInterceptorMutation,
	// EDIT INTERCEPTOR
	useEditInterceptorMutation,
	// DELETE INTERCEPTOR
	useDeleteInterceptorMutation,
	// CREATE DEVICE
	useCreateDeviceMutation,
	// CONTACT US
	useContactUsMutation
} = configuration;
